const AUTH_KEYS = ["auth_token", "auth_name", "role", "id"];

export function customerToken() {
  return sessionStorage.getItem("auth_token") || "";
}

export function customerName() {
  return sessionStorage.getItem("auth_name") || "";
}

export function customerRole() {
  return sessionStorage.getItem("role") || "";
}

export function isCustomerLoggedIn() {
  return customerToken() !== "";
}

export function saveCustomerSession(payload) {
  const token = payload.token || "";
  const name = payload.username || payload.name || "";
  const role = payload.role || "";
  const id = payload.id != null ? String(payload.id) : "";

  sessionStorage.setItem("auth_token", token);
  if (name) {
    sessionStorage.setItem("auth_name", name);
  }
  sessionStorage.setItem("role", role);
  if (id) {
    sessionStorage.setItem("id", id);
  }
}

export function clearCustomerSession() {
  AUTH_KEYS.forEach((key) => {
    sessionStorage.removeItem(key);
    localStorage.removeItem(key);
  });
}

export function restoreCustomerSession() {
  // Remove bearer tokens written by older releases; users sign in again safely.
  AUTH_KEYS.forEach((key) => {
    localStorage.removeItem(key);
  });
}

export function nextPathAfterLogin(search) {
  const params = new URLSearchParams(search || "");
  const next = params.get("redirect") || "";
  if (next.indexOf("/") === 0 && next.indexOf("//") !== 0 && next.indexOf("/admin") !== 0) {
    return next;
  }
  return "/account";
}
